var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHoldingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.87533 0.0836182C5.70957 0.0836347 5.55061 0.149488 5.4334 0.266695C5.3162 0.383901 5.25034 0.542863 5.25033 0.708618V3.83362H3.79199C2.07345 3.83362 0.666992 5.24008 0.666992 6.95862V12.792C0.666992 14.5105 2.07345 15.917 3.79199 15.917H14.2087C15.9272 15.917 17.3337 14.5105 17.3337 12.792V6.95862C17.3337 5.24008 15.9272 3.83362 14.2087 3.83362H12.7503V0.708618C12.7503 0.542863 12.6845 0.383901 12.5672 0.266695C12.45 0.149488 12.2911 0.0836347 12.1253 0.0836182H5.87533ZM6.50033 1.33362H11.5003V3.83362H6.50033V1.33362ZM3.79199 5.08362H5.87533H12.1253H14.2087C15.2518 5.08362 16.0837 5.91549 16.0837 6.95862V12.792C16.0837 13.8351 15.2518 14.667 14.2087 14.667H3.79199C2.74887 14.667 1.91699 13.8351 1.91699 12.792V6.95862C1.91699 5.91549 2.74887 5.08362 3.79199 5.08362Z",
    fill: "#131313"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoldingIcon);
export default __webpack_public_path__ + "static/media/holding-icon.68ccac3ed6d55e766d1ea18670ef03fe.svg";
export { ForwardRef as ReactComponent };